



import React from 'react';
import { Outlet } from 'react-router-dom';
import BusinessHeader from '../Layout/BusineesHeader';

const BusinessLayout = () => {
  return (
    <div className="business-layout">
      <BusinessHeader />
      
      {/* Main content area */}
      <main className="business-main">
        <Outlet />
      </main>

      <style dangerouslySetInnerHTML={{ __html: `
        .business-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        .business-main {
          padding-top: 72px; /* Standard mobile offset */
          background: #FAF9F6;
          min-height: calc(100vh - 72px);
          flex: 1;
        }
        @media (min-width: 992px) {
          .business-main {
            padding-top: 88px; /* Original web view offset */
            min-height: calc(100vh - 88px);
          }
        }
      ` }} />
    </div>
  );
};

export default BusinessLayout;